<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<orbit-table id="refund-ticket-price-type-list" [config]="tableConfig" [rows]="ticketsFormArray.controls"
  [resultCount]="ticketsFormArray.controls.length" [totalCount]="ticketsFormArray.controls.length">
  <ng-template orbitTableCell="ticketType" let-group><span class="info-label">{{ group.value.ticketType }}</span></ng-template>
  <ng-template orbitTableCell="ticketNumber" let-group><span class="info-label">{{ group.value.ticketNumber }}</span></ng-template>
  <ng-template orbitTableCell="ticketPrice" let-group><span class="info-label">{{ group.value.ticketPrice | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="ticketPricePaid" let-group><span class="info-label">{{ group.value.ticketPricePaid | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="ticketRefundType" let-group>
    <div [formGroup]="group">
      <mat-radio-group formControlName="ticketRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </ng-template>
  <ng-template orbitTableCell="bookingFee" let-group><span class="info-label">{{ group.value.bookingFee | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="bookingFeePaid" let-group><span class="info-label">{{ group.value.bookingFeePaid | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="bookingFeeRefundType" let-group>
    <div [formGroup]="group">
      <mat-radio-group formControlName="bookingFeeRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </ng-template>
  <ng-template orbitTableCell="venueLevy" let-group><span class="info-label">{{ group.value.venueLevy | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="venueLevyPaid" let-group><span class="info-label">{{ group.value.venueLevyPaid | number:'1.2-2' }}</span></ng-template>
  <ng-template orbitTableCell="venueLevyFeeRefundType" let-group>
    <div [formGroup]="group">
      <mat-radio-group formControlName="venueLevyFeeRefundType" class="refund-option-radio-group">
        <div class="flex-layout-column flex-layout-align-start">
          <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
            <span class="radio-button-text">{{ type.text }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </ng-template>
  <ng-template orbitTableCell="paymentStatus" let-group><span class="info-label">{{ group.value.paymentStatus }}</span></ng-template>
  <ng-template orbitTableCell="ticketStatus" let-group><span class="info-label">{{ group.value.ticketStatus }}</span></ng-template>
  <ng-template orbitTableCell="dispatchStatus" let-group><span class="info-label">{{ group.value.dispatchStatus }}</span></ng-template>
</orbit-table>
